import React from 'react';
import _ from 'lodash';
import { FormControlLabel, Typography, Radio, Stack, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { useMutation } from 'react-fetching-library';
import { useDispatch, useSelector } from 'react-redux';

import { ConfirmDialog } from '../../../components-core/ConfirmDialog';
import { submitModuleViewAction, updateEmployeeConfigAction } from '../../../services/request';
import { setOrderHiddenColumns, setOrderFilters, setOrderColumnsWidth, setOrderColumnsSequence } from '../../../services/redux-actions';

export const ViewList = props => {
  const { data, deleteViewCallback, getViewDataCallback, commitFiltersCallback } = props;
  const dispatch = useDispatch();
  const { employeeId, employeeConfigId } = useSelector(state => state.app);
  const { mutate } = useMutation(submitModuleViewAction);
  const { mutate: configMutate } = useMutation(updateEmployeeConfigAction);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const [idToDelete, setIdToDelete] = React.useState(null);

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', idToDelete);
    if (!error) {
      deleteViewCallback(idToDelete);
      setConfirmDeleteOpen(false);
    }
  };

  const handleViewChange = id => {
    const viewData = getViewDataCallback(id);
    const { payload: hiddenColumnsPayload } = dispatch(setOrderHiddenColumns(viewData.order_hidden_columns));
    const { payload: filtersPayload } = dispatch(setOrderFilters(viewData.order_filters));
    const { payload: columnsWidthPayload } = dispatch(setOrderColumnsWidth(viewData.order_columns_width));
    const { payload: columnsSequencePayload } = dispatch(setOrderColumnsSequence(viewData.order_columns_sequence));
    setTimeout(commitFiltersCallback, 100);
    // const { error } = await configMutate({ order_filters: filtersPayload,
    //   order_hidden_columns: hiddenColumnsPayload,
    //   order_columns_width: columnsWidthPayload,
    //   order_columns_sequence: columnsSequencePayload,
    //   employee: employeeId }, employeeConfigId);
  };

  return (
    <TreeView
      sx={{ mt: 2 }}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpanded={['all']}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultEndIcon={null}
    >
      <TreeItem nodeId="1" label={<Typography sx={{ padding: 1 }}>Widoki</Typography>}>
        {_.map(data, (obj, key) => <TreeItem key={key} nodeId={(key + 2).toString()} onClick={() => handleViewChange(obj.id)}
          label={
            <FormControlLabel value={obj.id} control={
              <Tooltip title="Wczytaj widok" sx={{ pr: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: 240, pt: 1, pb: 1 }}>
                  {obj.name}
                  <Tooltip title="Usuń widok...">
                    <DeleteIcon color="error" sx={{ ml: 'auto', zIndex: 999999 }} onClick={() => {
                      setConfirmDeleteOpen(true);
                      setIdToDelete(obj.id);
                    }} />
                  </Tooltip>
                </Stack>
              </Tooltip>}
            />}
        />
        )}
      </TreeItem>
      <ConfirmDialog
        title="Usunąć Widok?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
      >
        Czy na pewno chcesz usunąć ten widok?
      </ConfirmDialog>
    </TreeView>
  );
};
